<template>
    <div>
        <!-- <div>
            <button @click="printEditorHtml">print html</button>
            <button @click="insertTextHandler">insert text</button>
            <button @click="disableHandler">disable</button>
        </div> -->
        <div  style="border: 1px solid #ccc; margin-top: 10px;">
            <!-- 工具栏 -->
            <Toolbar
                style="border-bottom: 1px solid #ccc"
                :editor="editor"
                :defaultConfig="toolbarConfig"
            />
            <!-- 编辑器 -->
            <Editor
            :style="{height:params.editorHeight ? params.editorHeight+'px' : '250px'}"
                style="overflow-y: hidden;"
                :defaultConfig="editorConfig"
                v-model="params.value"
                @onChange="onChange"
                @onCreated="onCreated"
                @onBlur="onBlur"
                @onFocus ="onFocus "
            />
        </div>
        <!-- <div style="margin-top: 10px;">
            <textarea
                v-model="html"
                readonly
                style="width: 100%; height: 200px; outline: none;"
            ></textarea>
        </div> -->
    </div>
</template>

<script>
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import { SlateEditor, SlateElement, SlateNode,SlateTransforms } from '@wangeditor/editor'
import Cookies from 'js-cookie'
export default {
    name: 'MyEditor',
    components: { Editor, Toolbar },
    props: {
            params: {
                type: Object,
                default: function(){
                    return {}
                }
            },
        },
    data() {
        return {
            editor: null,
            html: '',
            toolbarConfig: {
                // toolbarKeys: [ /* 显示哪些菜单，如何排序、分组 */ ],
                // excludeKeys: [ /* 隐藏哪些菜单 */ ],
            },
            editorConfig: {
                placeholder: '请输入内容...',
                // autoFocus: false,

                // 所有的菜单配置，都要在 MENU_CONF 属性下
                MENU_CONF: {
                    uploadImage:{
                        server: 'https://crmgate.efenda.cn/minio/upload?type=0&fileType=1',
                        // 跨域是否传递 cookie ，默认为 false
                        fieldName:'file',
                        headers: {
                            Authorization: Cookies.get('loginToken')
                        },
                        customInsert(res, insertFn) {                  // JS 语法
                            // res 即服务端的返回结果
                            console.log("上传图片富文本返回数据",res)
                            // 从 res 中找到 url alt href ，然后插入图片
                            let url = res.data.url || "";
                            let name = res.data.name || "";
                            insertFn(url, name, url)
                        },
                    }
                }
            }
        }
    },
    created () {
        console.log("富文本编辑器",this.params)
    },
    methods: {
        onCreated(editor) {
            this.editor = Object.seal(editor) // 【注意】一定要用 Object.seal() 否则会报错
            if(this.params.disabled){
                this.editor.disable();
                console.log("富文本禁用")
            }
            console.log("富文本实例",this.editor,this.params.disabled)
        },
        onChange(editor) {

            console.log("editor",editor.children)
            let htmlValue= editor.getHtml() || "";
            let text = editor.getText() || "";
            console.log("pppppppppppp",htmlValue,text)
            let replaceJoin = "";
            if(htmlValue && htmlValue.indexOf("</p>") != -1 && text){
                let htamlValueArr = [];
                htamlValueArr = htmlValue.split("</p>");
                console.log("htamlValueArr-----",htamlValueArr)
                for(let [index,item] of htamlValueArr.entries()){
                    if(item){
                        let itmValueStr = item+'</p>'
                        console.log("itmValueStr-----",itmValueStr)
                        let text = editor.children[index].children[0].text;
                        let replaceStr = itmValueStr.replaceAll('<p',`<p title='${text}'  `)
                            console.log("11111111111112",replaceStr,text)
                        replaceJoin += replaceStr;
                    }
                }

                console.log("testsssss",htamlValueArr,replaceJoin,htamlValueArr.length)
            }
            // this.params.value = "<p title='123123'>aaaaa</p>";
            this.params.value = replaceJoin;
            console.log('onChange', this.params.value) // onChange 时获取编辑器最新内容
        },
        onFocus(editor){
            console.log("obFocus",editor)

            // const nodeEntries = SlateEditor.nodes(editor, {
            //     match: (node) => {  // TS syntax
            //     // match: (node) => {          // JS syntax
            //         if (SlateElement.isElement(node)) {
            //             if (node.type === 'paragraph') {
            //                 console.log("=========qqqqqqqqqqqqqqqq",node)
            //                 return true // 匹配 paragraph
            //             }
            //         }
            //         return false
            //     },
            //     universal: true,
            // })

            // console.log('获取所有节点', nodeEntries)
            // if (nodeEntries == null) {
            //     console.log('当前未选中的 paragraph')
            // } else {
            //     for (let nodeEntry of nodeEntries) {
            //         const node2 = { type: 'paragraph', children: [{ text: 'bbb',title:"123132123123" }] }
            //         SlateTransforms.insertNodes(editor, [node2])
            //         const [node, path] = nodeEntry
            //         // SlateTransforms.setNodes(editor, {
            //         //     // @ts-ignore
            //         //     title:"123123132",
            //         //     children:{
            //         //         blod:'true'
            //         //     }
            //         // }, {
            //         //     // mode: 'highest' // 针对最高层级的节点
            //         //     mode: 'lowest' // 针对最高层级的节点
            //         // })
            //         const elem = editor.getParentNode(node);
            //         console.log('选中了 paragraph 节点', node)
            //         console.log('节点 path 是', path)

            //     }
            // }
        },
        //递归 深拷贝
        deepClone(obj){
            let objClone = Array.isArray(obj) ? [] :{};
            if(obj && typeof obj === 'object'){
                for(let key in obj){
                    if(obj.hasOwnProperty(key)){
                        //判断obj子对象是否为对象，是  递归复制
                        if(obj[key] && typeof obj[key] === 'object'){
                            objClone[key] = this.deepClone(obj[key])
                        }else{
                            // 简单复制?
                            objClone[key] = obj[key]
                        }
                    }
                }
            }
            return objClone;
        },
        onBlur(editor) { 
            // let editorObj =this.deepClone(editor);
            // console.log("深拷贝===========editorArr",editorObj)
            // let editorArr =editorObj.children;
            // for(let item of editorArr){
            //     if(item.type == 'paragraph'){
            //         item.children[0] = { text:'1',bold:true}
            //         console.log("===========item",item)
            //     }
            // }
            // console.log("深拷贝---修改0--------===========editorArr",editorArr)

            
            // this.params.value = replaceJoin;
            // this.params.value = "<p title='123123'>aaaaa</p>";
            // this.params.value = "<p><span style=\"color: rgb(130, 0, 20);\">aaaaa</span></p>";
            // console.log('onBlur',replaceJoin,"====]]]]]]]]]]]]]]]]]",this.params.value) 
        },
        insertTextHandler() {
            const editor = this.editor
            if (editor == null) return
            editor.insertText(' hello ')
        },
        printEditorHtml() {
            const editor = this.editor
            if (editor == null) return
            console.log(editor.getHtml())
        },
        disableHandler() {
            const editor = this.editor
            if (editor == null) return
            editor.disable()
        },
    },
    mounted() {
        // 模拟 ajax 请求，异步渲染编辑器
        // setTimeout(() => {
        //     this.html = '<p>Ajax 异步设置内容 HTML</p>'
        // }, 1500)
    },
    
    destroyed () {
        
        this.$off();
    },
}
</script>

<style src="@wangeditor/editor/dist/css/style.css"></style>



// WEBPACK FOOTER //
// src/components/editor/MyEditorTitle.vue